import { Injectable } from '@angular/core';
import { Router, CanActivate } from '@angular/router';
import { UserService } from 'src/app/core';

@Injectable()
export class RestoreGuard implements CanActivate {
    constructor(
        private router: Router,
        private userService: UserService
    ) { }

    canActivate(): boolean {
        if (!this.userService.cambiarPassword()) {
            this.router.navigate(['']);
        }
        return true;
    }
}